export default "__VITE_ASSET__BOewHDac__"